import { Stack } from '@mui/material';
import { FC } from 'react';
import SidebarLayout from '../../elements/SidebarLayout/SidebarLayout';
import VerticalSplitPane from '../../elements/VerticalSplitPane/VerticalSplitPane';
import ArtifactsTable from '../components/Table/ArtifactsTable';
import ArtifactDrawerContainer from './ArtifactDrawerContainer';
import ArtifactsEmptyPage from './ArtifactsEmptyPage';
import ArtifactsSideBarContainer from './ArtifactsSidebarContainer';
import ArtifactsTopFiltersContainers from './ArtifactsTopFiltersContainer';

const ArtifactsContainer: FC = () => {
  return (
    <SidebarLayout aside={<ArtifactsSideBarContainer />}>
      <Stack direction='column' height='100%' sx={{ overflowY: 'auto' }}>
        <VerticalSplitPane
          content={
            <>
              <ArtifactsTopFiltersContainers />
              <ArtifactsEmptyPage />
              <ArtifactsTable />
            </>
          }>
          {({ className }) => <ArtifactDrawerContainer className={className} />}
        </VerticalSplitPane>
      </Stack>
    </SidebarLayout>
  );
};

export default ArtifactsContainer;
